import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';
import { itemService } from '@/services/item';
import { useVuelidate } from '@vuelidate/core';
import { maxValue, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useItemEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: route.params.itemId,
        name: '',
        ruby: 0,
        quantity: null,
        image: null,
        imageStatus: null,
        imageFile: null,
        canDelete: false
    });

    const validations = {
        imageFile: {},
        name: { required },
        ruby: { required, min: minValue(0), max: maxValue(32000) },
        quantity: { min: minValue(1), max: maxValue(100) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => itemService.item.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_ITEM.SYSTEM.INDEX })
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () => itemService.item.update(model.id, model.name, model.ruby, model.quantity, model.imageFile),
            onSuccess: () => router.push({ name: ROUTE_NAME_ITEM.SYSTEM.INDEX })
        }),
        remove: crudAction.confirmAndRemove({
            request: () => itemService.item.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_ITEM.SYSTEM.INDEX })
        })
    };

    return { model, v$, fetch, actions };
}
